<template>
  <div>
    <h3 class="is-size-5">Fire fighting </h3>
    <hr v-if="!isDense">
    <b-columns is-multiline>
      <b-column
        v-for="instruction in Object.keys(agentFireFighting)"
        :key="instruction"
        class="is-full"
      >
        <p class="has-text-weight-semibold">{{ instruction | underscoresToSpaces | capitalizeFirstLetter }} </p>
        <div class="wrap-text">
          {{ agentFireFighting[instruction] }}
        </div>
      </b-column>
      <b-column v-if="!omitFireDiamond">
        <fire-diamond
          v-if="agentFireDiamond"
          class="has-text-centered-mobile"
          :input="agentFireDiamond"
          :size="125"
        />
      </b-column>
    </b-columns>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FireDiamond from './FireDiamond'

export default {
  components: {
    FireDiamond
  },
  props: {
    omitFireDiamond: {
      type: Boolean,
      default: false
    },
    isDense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['agentFireFighting', 'agentFireDiamond'])
  }
}
</script>
